import { B2B_PACKAGE_MANAGEMENT } from "api/ApiPath";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import client from "api/client";
import { IB2BPackageManagementRepository } from "features/packageManagement/b2bPackageManagement/domain/repositories/IB2BPackageManagementRepository";
import { injectable } from "tsyringe";
import { B2BPackagePriorityRequestModel } from "./model/actions/b2bPackagePriority/B2BPackagePriorityRequestModel";
import { CreateB2BPackageRequestModel } from "./model/actions/CreateB2BPackageRequestModel";
import { B2BPackageDetailResponseModel } from "./model/detail/B2BPackageDetailResponseModel";
import { B2BInventoryExcelRequestModel } from "./model/inventoryForB2BPackage/B2BInventoryExcelRequestModel";
import { InventoryForB2BPackageResponseModel } from "./model/inventoryForB2BPackage/InventoryForB2BPackageResponseModel";
import { B2BPackageForTransQueryModel } from "./model/listForTrans/B2BPackageForTransRequestModel";
import { B2BPackageForTransResponseModel } from "./model/listForTrans/B2BPackageForTransResponseModel";
import { B2BPackageRequestModel } from "./model/mainList/B2BPackageRequestModel";
import { B2BPackageResponseModel } from "./model/mainList/B2BPackageResponseModel";

@injectable()
export class B2BPackageImpl implements IB2BPackageManagementRepository {
  async getDataPackageList(
    params: B2BPackageRequestModel,
  ): Promise<ListBaseApiResponseModel<B2BPackageResponseModel>> {
    return await client?.get(
      B2B_PACKAGE_MANAGEMENT.GET_DATA_PACKAGES_LIST,
      params,
    );
  }

  async createDataPackage(
    body: CreateB2BPackageRequestModel,
  ): Promise<BaseApiResponseModel<CreateB2BPackageRequestModel>> {
    return await client?.post(
      B2B_PACKAGE_MANAGEMENT.CREATE_DATA_PACKAGES,
      body,
    );
  }

  async deleteDataPackage(
    id: string,
  ): Promise<BaseApiResponseModel<CreateB2BPackageRequestModel>> {
    return await client?.delete(
      B2B_PACKAGE_MANAGEMENT.DELETE_DATA_PACKAGES + "/" + id,
    );
  }

  async updateDataPackage(
    id: string,
    body: CreateB2BPackageRequestModel,
  ): Promise<BaseApiResponseModel<CreateB2BPackageRequestModel>> {
    return await client?.put(B2B_PACKAGE_MANAGEMENT.UPDATE_DATA_PACKAGES, {
      id,
      ...body,
    });
  }

  async getTransaction(
    params: B2BPackageForTransQueryModel,
  ): Promise<BaseApiResponseModel<B2BPackageForTransResponseModel>> {
    return await client?.get(B2B_PACKAGE_MANAGEMENT.GET_TRANSACTION, params);
  }

  async getDataGroup(): Promise<
    ListBaseApiResponseModel<B2BPackageResponseModel>
  > {
    return client?.get(B2B_PACKAGE_MANAGEMENT.GET_DATA_GROUP);
  }

  async searchInventory(
    name: string,
  ): Promise<ListBaseApiResponseModel<InventoryForB2BPackageResponseModel>> {
    return client?.get(B2B_PACKAGE_MANAGEMENT.SEARCH_INVENTORY, { name });
  }

  async setTopPriority(
    body: B2BPackagePriorityRequestModel,
  ): Promise<BaseApiResponseModel<unknown>> {
    return await client?.put(B2B_PACKAGE_MANAGEMENT.SET_TOP_PRIORITY, body);
  }

  async getPackageDetail(
    id: string,
  ): Promise<BaseApiResponseModel<B2BPackageDetailResponseModel>> {
    return await client?.get(B2B_PACKAGE_MANAGEMENT.DETAIL_DATA_PACKAGES, {
      id,
    });
  }

  async exportDataCodeReport(
    params: B2BPackageForTransQueryModel,
  ): Promise<any> {
    return await client?.export(
      B2B_PACKAGE_MANAGEMENT.EXPORT_DATA_CODE_REPORT,
      params,
    );
  }

  async exportTransaction(params: B2BPackageForTransQueryModel): Promise<any> {
    return await client?.export(
      B2B_PACKAGE_MANAGEMENT.EXPORT_TRANSACTION,
      params,
    );
  }

  async importInventoryFromExcel(
    data: B2BInventoryExcelRequestModel,
  ): Promise<ListBaseApiResponseModel<InventoryForB2BPackageResponseModel>> {
    return await client.post(
      B2B_PACKAGE_MANAGEMENT.IMPORT_INVENTORY_FROM_EXCEL,
      data,
      { headers: { "Content-Type": "multipart/form-data" } },
    );
  }
}
